import styled from "styled-components";
import {presentation} from "../proto/compiled";
import {STATIC_BASE} from "../strings";
import {useContext} from "react";
import {TpStoreContext} from "../App";

const Container = styled.div`
  position: absolute;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;

  * {
    pointer-events: auto;
  }
`;

const ContentVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

interface PresentationContentVideoProps {
    content: presentation.IContentVideo
}

export const PresentationContentVideo = (props: PresentationContentVideoProps) => {
    const store = useContext(TpStoreContext);

    const handleVideoEnd = () => {
        if (props.content.nextSlideOnEnd) {
            store.presentation?.next();
        }
    };

    return <Container>
        <ContentVideo
            src={STATIC_BASE + props.content.src}
            style={props.content.style ?? {}}
            loop={!props.content.nextSlideOnEnd}
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
        />
    </Container>;
}